import { library } from "@fortawesome/fontawesome-svg-core";
import { faMinus, faShoppingBag, faUserCog, faBan, faCheck } from "@fortawesome/free-solid-svg-icons";
import { faApple } from "@fortawesome/free-brands-svg-icons";
import { faPlus, faVolumeUp, faUser, faMobileAlt, faTabletAlt, faDesktop, faUsers, faShoppingCart, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt, faEdit } from "@fortawesome/free-regular-svg-icons";


library.add(faApple, faShoppingBag, faUserCog, faPlus, faVolumeUp, faTrashAlt, faMinus, faUser, faMobileAlt, faTabletAlt, faDesktop, faUsers, faShoppingCart, faEdit, faInfoCircle, faCheck, faBan);
